import http from './http';

const fetchAll = async (resource) => {
    const size = 1000;
    let page = 0;
    let totalPages = 1;
    const options = [];

    while (page < totalPages) {
        // eslint-disable-next-line no-await-in-loop
        const { data } = await http.get(`/case-api/${resource}?size=${size}&page=${page}&sort=name,id&archived=false`);
        options.push(...data.content);
        totalPages = data.totalPages;
        page += 1;
    }

    return options;
};

export const fetchAllClinics = () => fetchAll('clinics');

export const fetchAllLabs = () => fetchAll('labs');
